<template>
  <standard-container
    :title="$t('stats.period')"
    overflow="hidden"
    content-height="23vh"
    footer-height="0px"
  >
    <template v-slot:content>
      <v-flex>
        <v-row>
          <v-col>
            <v-menu
              v-model="showCalStart"
              min-width="auto"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="period.start"
                  :disabled="disabled"
                  :label="$t('schedule.date-from')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="period.start"
                :disabled="disabled"
                scrollable
                no-title
                :landscape="true"
                locale="fr-fr"
                first-day-of-week="1"
                @input="showCalStart = false"
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col>
            <v-menu
              v-model="showCalEnd"
              min-width="auto"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="period.end"
                  :disabled="disabled"
                  :label="$t('schedule.date-to')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="period.end"
                :disabled="disabled"
                scrollable
                no-title
                :landscape="true"
                locale="fr-fr"
                first-day-of-week="1"
                @input="showCalEnd = false"
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="mt-0 justify-center">
          <v-btn
            :disabled="disabled"
            @click="setPeriod()"
          >
            {{ $t("profile.sections.common.confirm") }}
          </v-btn>
        </v-row>
      </v-flex>
    </template>
  </standard-container>
</template>

<script>
// Components
import standardContainer from "../Common/StandardContainer";

export default {
  components: {
    standardContainer,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCalStart: false,
      showCalEnd: false,
      period: {
        start: new Date().toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10),
      },
    };
  },
  methods: {
    setPeriod() {
      if (this.period.start.length > 0 && this.period.end.length > 0) {
        this.$emit("periodDefined", this.period);
      }
    },
  },
};
</script>

<style></style>
